import { PropsWithChildren, ReactNode } from 'react';

import { LoadingButton } from '@/components/Form/LoadingButton';
import { ActionBar } from '@/components/Layout';

import { useTranslate } from '@/hooks/useTranslate';

import { FinanceQuestion } from '../../hooks';

import {
  ContentContainer,
  FinanceImg,
  FormContainer,
  ImageContainer,
  QuestionCounter,
  QuestionSubtitle,
  QuestionTitle,
} from './FinancesQuestionForm.styled.tsx';

type FinancesQuestionFormProps = {
  question: FinanceQuestion;
  title: string;
  imageUrl: string;
  subtitle?: ReactNode;
  onContinue?: () => void;
  disable?: boolean;
  isLoading?: boolean;
} & PropsWithChildren;

export function FinancesQuestionForm({
  question,
  title,
  subtitle,
  imageUrl,
  onContinue,
  children,
  disable,
  isLoading,
}: Readonly<FinancesQuestionFormProps>) {
  const { t } = useTranslate();

  return (
    <FormContainer component="form">
      <ImageContainer>
        <FinanceImg src={imageUrl} alt={'circle-icon'} />
      </ImageContainer>
      <QuestionCounter variant="body1">
        {t('moreInfo.form.yourFinances.questionCounter', {
          no: question,
          total: FinanceQuestion.Complete - 1,
        })}
      </QuestionCounter>
      <QuestionTitle variant="h4">{title}</QuestionTitle>
      {subtitle && (
        <QuestionSubtitle variant="body2" component="div">
          {subtitle}
        </QuestionSubtitle>
      )}
      <ContentContainer>{children}</ContentContainer>
      <ActionBar sx={{ mt: 'auto' }}>
        <LoadingButton
          variant="outlined"
          fullWidth
          onClick={onContinue}
          disabled={disable}
          isLoading={isLoading}
        >
          {t('moreInfo.form.yourFinances.button.continue')}
        </LoadingButton>
      </ActionBar>
    </FormContainer>
  );
}
